import {
    BlockStack,
    Text,
    Thumbnail,
    Badge,
    Button,
    Card,
    InlineStack,
    ButtonGroup,
    Checkbox,
    Modal,
} from '@shopify/polaris';
import { MobileCancelMajor, NoteMinor } from '@shopify/polaris-icons';
import { Table } from 'antd';
import React, { useEffect, useRef, useState } from 'react';
import { DI, DIProps } from '../../../../../Core';
import { columnsVariant } from './constents';

import ActionPopOver from '../ActionPopOver';
import SyncModal from '../SyncModal';
import { DataToSend } from '../../Utilities/Helper';
import { useTranslation } from 'react-i18next';

interface Props extends DIProps {
    syncNecessaryInfo: () => void;
    syncConnectorInfo: () => void;
    selectedRows?: any;
    rows: any;
    FiftyPlus: any;
    setFiftyPlus: (data: any) => void
    setselectedRows: (data: any) => void
    totalPages: any,
    dataforRow: any;
    handleFiftyPlus: () => void
    allFiltersNew: any,
    refreshAction: () => void
}

const VariantTable = (props: Props) => {
    const tableref = useRef<HTMLTableElement>(document.createElement("table"));
    const { t } = useTranslation();

    const { rows, selectedRows, FiftyPlus, setFiftyPlus, refreshAction, setselectedRows, totalPages, dataforRow, handleFiftyPlus, allFiltersNew } = props
    const [popover, setpopover] = useState(false)
    const [syncModal, setsyncModal] = useState(false);
    const [actiontype, setactiontype] = useState({});
    const [syncmodalLoading, setsyncmodalLoading] = useState(false);
    const [syncActionCheckbox, setsyncActionCheckbox] = useState<any>({
        inventory: false,
        price: false,
        image: false,
        loading: false
    })
    const [syncActionModal, setsyncActionModal] = useState(false)

    useEffect(() => {
        if (selectedRows.length > 0) {
            tableref.current?.classList.add("header-hidden");
        } else {
            tableref.current?.classList.remove("header-hidden");
        }
    }, [selectedRows]);

    const handleHeaderSelectAll = (row: any) => {
        if (selectedRows.length > 0 && selectedRows.length == dataforRow.length) {
            setselectedRows([]);
        }
        else if (row.length > 0 && dataforRow.length > row.length) {
            let rowTempData: any = [];
            rows.map((row: any) => rowTempData.push(row?.key));
            setselectedRows(rowTempData);
        }
    }

    const activator = (
        <Button disclosure onClick={() => {
            setpopover(!popover)
        }} id='popoverActivator' >
            {t("Select Actions")}
        </Button >
    );

    const handleCheckboxChange = (key: string) => {
        setsyncActionCheckbox((prev: any) => ({
            ...prev,
            [key]: !prev[key],
        }));
    };
    // function to handle Fifty Plus

    // Function to execute API calls for Amazon Sync Actions
    const syncAction = (Data: any, source_product_id = undefined) => {
        let url: string = '';
        let temp: any = [];
        let data: any = {};
        setsyncmodalLoading(true);
        if (selectedRows.length > 0) {
            temp.push(...selectedRows)
        }
        let SourceProductIds: Array<string> = FiftyPlus ? [] : source_product_id == undefined ? selectedRows.length > 0 ? temp : selectedRows : [source_product_id];
        let params: any = {
            ...DataToSend(props),
            source_product_ids: SourceProductIds,
            // limit: SourceProductIds.length,
            activePage: 1,
        };
        FiftyPlus ? params['profile_id'] = 'all_products' : null;
        Object.keys(allFiltersNew)?.map((key: any) => {
            if (allFiltersNew[key].change) {
                data[allFiltersNew[key]['value']] = {
                    [allFiltersNew[key]?.['selectValue']]: allFiltersNew[key]?.['textValue']
                }
            }
        });
        if (Object.keys(data).length > 0 && FiftyPlus) {
            delete params['profile_id'];
            params['filter'] = data
            params['useRefinProduct'] = true;
        }

        FiftyPlus && delete params['source_product_ids'];
        // FiftyPlus ? DataToSend['limit'] = '500' : null
        switch (Data) {
            case 'Sync Product':
                url = 'connector/product/productSync';
                params['filter'] = {
                    ...params['filter'],
                    "items.status": {
                        "10": ["Inactive", "Incomplete", "Active", "Uploaded"]
                    }
                }
                break;
            case 'Sync Inventory':
                url = 'connector/product/inventorySync';
                params['filter'] = {
                    ...params['filter'],
                    "items.status": {
                        "10": ["Inactive", "Incomplete", "Active", "Uploaded"]
                    }
                }

                break;
            case 'Amazon Lookup':
                url = 'connector/product/searchProduct';
                break;
            case 'Sync Price':
                url = 'connector/product/priceSync';
                params['filter'] = {
                    ...params['filter'],
                    "items.status": {
                        "10": ["Inactive", "Incomplete", "Active", "Uploaded"]
                    }
                }
                break;
            case 'Sync Image':
                url = 'connector/product/imageSync';
                params['filter'] = {
                    ...params['filter'],
                    "items.status": {
                        "10": ["Inactive", "Incomplete", "Active", "Uploaded"]
                    }
                }
                break;
            case 'Delete Product':
                url = 'connector/product/deleteFromMarketplace';
                params['filter'] = {
                    ...params['filter'],
                    "items.status": {
                        "10": ["Inactive", "Incomplete", "Active", "Uploaded"]
                    }
                }
                break;
            case 'Unified':
                url = 'connector/product/group';

                const actionMap: any = {
                    price: 'price_sync',
                    inventory: 'inventory_sync',
                    image: 'image_sync',
                };

                const selectedActions = Object.keys(syncActionCheckbox || {})
                    .filter(key => syncActionCheckbox[key])
                    .map(key => actionMap[key]);

                // Fully reinitializing `params` for Unified case
                let unifiedParams: any = {
                    ...DataToSend(props),
                    source_product_ids: FiftyPlus
                        ? []
                        : source_product_id == undefined
                            ? selectedRows.length > 0
                                ? temp.length !== 0
                                    ? temp
                                    : selectedRows
                                : selectedRows
                            : [source_product_id],
                    activePage: 1,
                    "operationType": "groupAction",
                    "groupWiseAction": selectedActions
                };

                if (FiftyPlus) {
                    unifiedParams['profile_id'] = 'all_products';
                    Object.keys(allFiltersNew || {}).forEach((key: any) => {
                        if (allFiltersNew[key].change) {
                            data[allFiltersNew[key]['value']] = {
                                [allFiltersNew[key]['selectValue']]: allFiltersNew[key]['textValue']
                            };
                        }
                    });
                    if (Object.keys(data).length > 0) {
                        delete unifiedParams['profile_id'];
                        unifiedParams['filter'] = data;
                        unifiedParams['useRefinProduct'] = true;
                    }
                    delete unifiedParams['source_product_ids'];
                }

                // Adding default item status filter
                unifiedParams['filter'] = {
                    ...unifiedParams['filter'],
                    "items.status": {
                        "10": ["Inactive", "Incomplete", "Active", "Uploaded"]
                    }
                };

                unifiedParams['useRefinProduct'] = true;
                unifiedParams['usePrdOpt'] = true;
                unifiedParams['projectData'] = { marketplace: 0 };

                // Replace the outer `params` with this for Unified
                params = unifiedParams;

                break;
            case 'Upload Product':
                url = 'connector/product/upload';
                break;
        }
        params['useRefinProduct'] = true;


        props.di.POST(url, params).then((response) => {
            if (response.success) {
                let filter: any = { ...allFiltersNew };
                setsyncModal(false);
                setsyncmodalLoading(false);
                setpopover(!popover);
                refreshAction()
                props.success(response.message);
                let selected = JSON.parse(props.di.globalState?.get('selected_for_tour') ?? '{}')?.selected
                setselectedRows([])
            } else {
                setsyncModal(false);
                setpopover(!popover);
                setsyncmodalLoading(false);
                props.error(response.message);
            }
        });
    };
    const isAnyChecked = Object.values(syncActionCheckbox || {}).some(Boolean);




    return (
        <>
            {rows.length > 0 && <Table
                sticky
                columns={columnsVariant(t)}
                ref={tableref}
                dataSource={rows}
                rowSelection={{
                    onSelect: (value, _, selected) => {
                        let temp = [...selectedRows];
                        setFiftyPlus(false);
                        if (temp.includes(value?.key)) {
                            temp.splice(temp.indexOf(value['key']), 1);
                        } else temp.push(value['key']);
                        setselectedRows([...temp]);
                    },
                    onSelectAll: (value, rows) => {
                        setFiftyPlus(false);
                        let temp: Array<any> = [];
                        rows.forEach((row) => temp.push(row?.key))
                        setselectedRows([...temp]);
                    },
                    selectedRowKeys: selectedRows
                }}
                pagination={false}
                size="middle"
                scroll={{ x: 700 }}
                summary={() =>
                    selectedRows.length > 0 ?
                        <Table.Summary fixed="top">
                            <Table.Summary.Row>
                                <Table.Summary.Cell index={0} colSpan={11}>
                                    <div className="toolbar" style={{ backgroundColor: '#fafafa', padding: '9px' }}>
                                        <InlineStack gap="400" blockAlign="center" align="start">
                                            <ButtonGroup variant="segmented">
                                                <Button
                                                    size="slim"
                                                    icon={<Checkbox
                                                        onChange={() => handleHeaderSelectAll(selectedRows)}
                                                        checked={selectedRows.length < dataforRow.length ? 'indeterminate' : true}
                                                        label='' labelHidden
                                                    />}
                                                    loading={false}>
                                                    {FiftyPlus ? `50+ ${t("Selected")}` : `${selectedRows.length} ${t("Selected")}`}
                                                </Button>
                                                <Button
                                                    onClick={() => {
                                                        setselectedRows([]);
                                                        setFiftyPlus(false);
                                                    }}
                                                    size="medium"
                                                    icon={MobileCancelMajor}
                                                />
                                            </ButtonGroup>
                                            {totalPages > 1 &&
                                                <InlineStack gap="100">
                                                    {!FiftyPlus &&
                                                        <Button onClick={handleFiftyPlus} size="medium" variant="plain">
                                                            {t("Select all 50+ products")}
                                                        </Button>
                                                    }
                                                    {FiftyPlus && <Text as="p">{t("All 50+ products are selected.")}</Text>}
                                                    {
                                                        FiftyPlus && (
                                                            <Button
                                                                onClick={() => {
                                                                    setFiftyPlus(false);
                                                                    setselectedRows([]);
                                                                }}
                                                                variant="plain">
                                                                {t("Undo")}
                                                            </Button>
                                                        )}
                                                </InlineStack>
                                            }
                                            <ActionPopOver
                                                type={"ChildRow"}
                                                t={t}
                                                setsyncActionModal={setsyncActionModal}
                                                inProgress={true}
                                                popover={popover}
                                                setpopover={setpopover}
                                                activator={activator}
                                                setactiontype={setactiontype}
                                                setsyncModal={setsyncModal}
                                                selectedRows={selectedRows}
                                            />
                                        </InlineStack>
                                    </div>
                                </Table.Summary.Cell>
                            </Table.Summary.Row>
                        </Table.Summary>
                        :
                        null
                }
            />}
            {syncModal && Object.keys(actiontype).length > 0 && (
                <SyncModal
                    {...props}
                    t={t}
                    syncmodalLoading={syncmodalLoading}
                    actiontype={actiontype}
                    syncAction={syncAction}
                    syncModal={syncModal}
                    setsyncModal={setsyncModal}
                    // totalProdCount={totalProductCount}
                    FiftyPlus={FiftyPlus}
                // activePlan={activePlan}
                />
            )}
            <Modal
                open={syncActionModal}
                size="small"
                primaryAction={{
                    content: t('Proceed'),
                    onAction: () => {
                        const selectedActions = Object.entries(syncActionCheckbox)
                            .filter(([key, value]) => key !== 'loading' && value)
                            .map(([key]) => key);

                        let payload = 'Unified';

                        if (selectedActions.length === 1) {
                            const actionMap: any = {
                                price: 'Sync Price',
                                image: 'Sync Image',
                                inventory: 'Sync Inventory'
                            };
                            payload = actionMap[selectedActions[0]];
                        }

                        syncAction(payload);
                    },
                    disabled: !isAnyChecked,
                    loading: syncActionCheckbox?.loading
                }}
                onClose={() => {
                    setsyncActionCheckbox({
                        inventory: false,
                        price: false,
                        image: false,
                        loading: false
                    });
                    setsyncActionModal(false)
                }}
                secondaryActions={[
                    {
                        content: t('Cancel'),
                        onAction: () => {
                            setsyncActionCheckbox({
                                inventory: false,
                                price: false,
                                image: false,
                                loading: false
                            }); setsyncActionModal(false)
                        },
                    },
                ]}
                title={t("Sync Actions")}
            >
                <Modal.Section>
                    <InlineStack gap="1200" align="start">
                        <Checkbox
                            checked={syncActionCheckbox?.inventory}
                            onChange={() => handleCheckboxChange('inventory')}
                            label="Inventory"
                        />
                        <Checkbox
                            checked={syncActionCheckbox?.price}
                            onChange={() => handleCheckboxChange('price')}
                            label="Price"
                        />
                        <Checkbox
                            checked={syncActionCheckbox?.image}
                            onChange={() => handleCheckboxChange('image')}
                            label="Image"
                        />
                    </InlineStack>
                </Modal.Section>
            </Modal>
        </>
    );
};

export default DI(VariantTable);
